import { genericRequest } from "./genericRequest";

export const getFinancialSummary = async (perPage, offset, firstName, lastName) => {

  const data = await genericRequest(`https://wallets-neon.ponzilover.com/api/wallets_reports_home_page/?perPage=${perPage}&offset=${offset}&first_name=${firstName}&last_name=${lastName}`);
  return data || [];
};

export const getFinancialSummaryTotal = async (firstName, lastName) => {

  const totalRows = await genericRequest(`https://wallets-neon.ponzilover.com/api/wallets_reports_home_page/?getTotal=true&first_name=${firstName}&last_name=${lastName}`);
  return totalRows[0].total || 0;
};

export const getGroupsWallets = async (perPage, offset, fullName, address) => {
  const data = await genericRequest(`https://wallets-neon.ponzilover.com/api/wallets_groups/?perPage=${perPage}&offset=${offset}&full_name=${fullName}&address=${address}`);
  return data || [];
};

export const getGroupsWalletsTotal = async (fullName, address) => {
  const totalRows = await genericRequest(`https://wallets-neon.ponzilover.com/api/wallets_groups/?getTotal=true&full_name=${fullName}&address=${address}`);
  return totalRows[0].total || 0;
};

export const getInvestedTotal = async (users_id) => {
  const totalRows = await genericRequest(`https://users.ponzilover.com/api/invested/?users_id=${users_id}`);
  return totalRows.total_invested || 0;
};
